// let roomList = [];

// export function loadRooms(data) {
//   roomList = data;
//   return roomList;
// }

// export function getRooms() {
//   return roomList;
// }

// export function deleteRoom(id) {
//   roomList = roomList.filter((r) => r.id !== id);
//   return roomList;
// }

// export function updateRoom(updatedRoom) {
//   roomList = roomList.map((r) =>
//     r.id === updatedRoom.id ? updatedRoom : r
//   );
//   return roomList;
// }

// export function addRoom(room) {
//   roomList.push(room);
//   return roomList;
// }


// Load all rooms from localStorage
// src/services/roomService.js

// const ROOM_KEY = "rooms";

// // Get all rooms
// export function getRooms() {
//   return JSON.parse(localStorage.getItem(ROOM_KEY) || "[]");
// }

// // Save list of rooms
// function saveRooms(rooms) {
//   localStorage.setItem(ROOM_KEY, JSON.stringify(rooms));
// }

// // Add new room
// export function addRoom(room) {
//   const rooms = getRooms();
//   room.id = Date.now(); // unique ID
//   rooms.push(room);
//   saveRooms(rooms);
// }

// // Update existing room
// export function updateRoom(updatedRoom) {
//   const rooms = getRooms();
//   const newList = rooms.map((r) =>
//     r.id == updatedRoom.id ? updatedRoom : r
//   );
//   saveRooms(newList);
// }

// // Delete a room
// export function deleteRoom(id) {
//   const rooms = getRooms();
//   const newList = rooms.filter((r) => r.id != id);
//   saveRooms(newList);
// }

// // Get room by ID
// export function getRoomById(id) {
//   const rooms = getRooms();
//   return rooms.find((r) => r.id == id);
// }


import axios from "axios";

const API_URL = "http://localhost:8080/api/rooms";

export const getRooms = () => axios.get(API_URL);

export const getRoomById = (id) => axios.get(`${API_URL}/${id}`);

export const deleteRoom = (id) => axios.delete(`${API_URL}/${id}`);

export const addRoom = (room) => axios.post(API_URL, room);

export const editRoom = (room) =>
  axios.put(`${API_URL}/${room.id}`, room);



